import { render, staticRenderFns } from "./WorkApp.vue?vue&type=template&id=5e32d7b8"
import script from "./WorkApp.vue?vue&type=script&lang=js"
export * from "./WorkApp.vue?vue&type=script&lang=js"
import style0 from "../../../src/styles/app.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports